import { deleteAllCookies } from "../cookies/cookieUtils";

export async function adminRecruiterRole(userid, token, endpoint) {
    const body = {
      userid: userid
    };
    try {  
      const response = await fetch(endpoint + '/api/Authentication/VerifyRole', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      });
    
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        // Maybe fix the CORs issues?
        deleteAllCookies();
      }
    
      const data = await response.json();
      console.log(data.valid);
      
    
      if (data.valid === true) {
        return true;
      }
    } catch(exception) {
      deleteAllCookies();
    }
  
    return false;
  };

  export async function adminRole(userid, token, endpoint) {
    const body = {
      userid: userid
    };
    try {  
      const response = await fetch(endpoint + '/api/Authentication/VerifyAdmin', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      });
    
      if (!response.ok) {
        //throw new Error(`HTTP error! status: ${response.status}`);
        // Maybe fix the CORs issues?
        //deleteAllCookies();
        return false;
      }
    
      const data = await response.json();
      console.log('adminRole: ' + data.valid);
      
    
      if (data.valid === true) {
        return true;
      }
    } catch(exception) {
      deleteAllCookies();
    }
  
    return false;
  };